const returnUniqueValuesInArray = (input_array) => {
      console.log("inside returnUniqueValuesInArray");
      const tempArray = [];
      input_array.map( i => {
            if(!tempArray[i.name]) {
                  tempArray.push(i.name)
            }
      })
      console.log('tempArray inside returnUniqueValuesInArray : ' + tempArray)
      return tempArray;
};

export default returnUniqueValuesInArray;
